import script from "./UnidadeLista.vue?vue&type=script&setup=true&lang=js"
export * from "./UnidadeLista.vue?vue&type=script&setup=true&lang=js"

import "./UnidadeLista.vue?vue&type=style&index=0&id=25d1729c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d1729c"]])

export default __exports__